// src/moviesData.js
const moviesData = {
  movies: [
      {
          title: "Entertainment",
          description: "A comedy film about a man who goes to great lengths to inherit his wealthy grandfather's fortune, leading to a series of humorous situations.",
          youtubeLink: "https://www.youtube.com/embed/LXXkiUKDK4w?si=B9ZRwZUf-CtOptyb",
          thumbnail: "https://i.ytimg.com/vi/LXXkiUKDK4w/maxresdefault.jpg",
          genres: ["comedy", "drama"]
      },
      {
          title: "Suraj Pe Mangal Bhari",
          description: "A comedy film set in the backdrop of arranged marriages, where a detective uncovers humorous and shocking truths about potential suitors.",
          youtubeLink: "https://www.youtube.com/embed/_oRP8LJBPcY?si=F2PvlsftG2htR0Fd",
          thumbnail: "https://i.ytimg.com/vi/_oRP8LJBPcY/maxresdefault.jpg",
          genres: ["comedy", "romance"]
      },
      {
          title: "Magadheera",
          description: "A historical action film about reincarnation and revenge, blending epic storytelling with high-octane action.",
          youtubeLink: "https://www.youtube.com/embed/js4HJnv4Zu4?si=wksxqxkzW5ncXDs-",
          thumbnail: "https://i.ytimg.com/vi/js4HJnv4Zu4/maxresdefault.jpg",
          genres: ["action", "fantasy"]
      },
      {
          title: "Hera Pheri",
          description: "A comedy film about three hapless individuals who get entangled in a series of misadventures while trying to solve their financial troubles.",
          youtubeLink: "https://www.youtube.com/embed/TIQ5hrfermg?si=N4fLVZqC-RVs94Nz",
          thumbnail: "https://i.ytimg.com/vi/TIQ5hrfermg/maxresdefault.jpg",
          genres: ["comedy", "crime"]
      },
      {
          title: "World Famous Lover",
          description: "An exploration of love through the lives of several couples and their relationships, filled with drama and emotion.",
          youtubeLink: "https://www.youtube.com/embed/1odS6ynbWNo?si=xFcr-LQizN33nxRC",
          thumbnail: "https://i.ytimg.com/vi/1odS6ynbWNo/maxresdefault.jpg",
          genres: ["romance", "drama"]
      },
      {
          title: "Premam",
          description: "A coming-of-age romantic drama that follows the life and loves of a young man from his youth to adulthood.",
          youtubeLink: "https://www.youtube.com/embed/kgj6kc_hpFE?si=MDf8Y3AY9c3pjopK",
          thumbnail: "https://i.ytimg.com/vi/kgj6kc_hpFE/maxresdefault.jpg",
          genres: ["romance", "drama"]
      },
      {
          title: "The Super Khiladi 3",
          description: "An action-packed movie featuring thrilling stunts and an adventurous storyline.",
          youtubeLink: "https://www.youtube.com/embed/vkuiI430d_0?si=BARjewxsglZ2n43L",
          thumbnail: "https://i.ytimg.com/vi/vkuiI430d_0/maxresdefault.jpg",
          genres: ["action", "adventure"]
      },
      {
          title: "Dear Comrade",
          description: "A college student with a strong sense of justice battles for love and social justice, confronting various personal and societal issues.",
          youtubeLink: "https://www.youtube.com/embed/zzhfvt5vZHI?si=XFfU4ne4LJzQf1k5",
          thumbnail: "https://i.ytimg.com/vi/zzhfvt5vZHI/maxresdefault.jpg",
          genres: ["romance", "drama"]
      },
      {
          title: "Dhamaal",
          description: "A comedy film about four friends who find themselves on a wild adventure after discovering a hidden treasure.",
          youtubeLink: "https://www.youtube.com/embed/LKNHVDPKy7g?si=xzUffGPByW3b4sZq",
          thumbnail: "https://i.ytimg.com/vi/LKNHVDPKy7g/maxresdefault.jpg",
          genres: ["comedy", "adventure"]
      },
      {
          title: "Mr Majnu",
          description: "A charming and playful man tries to win over the woman he loves while navigating various romantic and personal challenges.",
          youtubeLink: "https://www.youtube.com/embed/zR52MgYhm_Q?si=FZK7v7PoJTneqNiP",
          thumbnail: "https://i.ytimg.com/vi/zR52MgYhm_Q/maxresdefault.jpg",
          genres: ["romance", "comedy"]
      },
      {
          title: "Fidaa",
          description: "A heartwarming love story that explores the relationship between a rural girl and a young man who falls in love with her.",
          youtubeLink: "https://www.youtube.com/embed/I3o-UeFZFKo?si=efnXqyPqihcdamJf",
          thumbnail: "https://i.ytimg.com/vi/I3o-UeFZFKo/maxresdefault.jpg",
          genres: ["romance", "drama"]
      },
      {
          title: "Maari 2",
          description: "A sequel that continues the story of the charismatic Maari, who takes on new challenges and adversaries.",
          youtubeLink: "https://www.youtube.com/embed/HbEV2n65qD8?si=GtzQCCHy7p0wOPum",
          thumbnail: "https://i.ytimg.com/vi/HbEV2n65qD8/maxresdefault.jpg",
          genres: ["action", "comedy"]
      },
      {
          title: "KGF",
          description: "A young man rises from poverty to become a powerful figure in the gold mining industry, fighting against oppression.",
          youtubeLink: "https://www.youtube.com/embed/ULEQb_l-N08?si=akzA5CkNWfpAJRCE",
          thumbnail: "https://i.ytimg.com/vi/ULEQb_l-N08/maxresdefault.jpg",
          genres: ["action", "drama"]
      },
      {
          title: "Suraj Pe Mangal Bhari",
          description: "A comedy film set in the backdrop of arranged marriages, where a detective uncovers humorous and shocking truths about potential suitors.",
          youtubeLink: "https://www.youtube.com/embed/_oRP8LJBPcY?si=F2PvlsftG2htR0Fd",
          thumbnail: "https://i.ytimg.com/vi/_oRP8LJBPcY/maxresdefault.jpg",
          genres: ["comedy", "romance"]
      },
      {
          title: "URI",
          description: "A military action film based on real events of the surgical strikes carried out by the Indian Army against terrorist camps in Pakistan.",
          youtubeLink: "https://www.youtube.com/embed/MT0hGJL6m7k?si=Tq78OdemB85KBL04",
          thumbnail: "https://mir-s3-cdn-cf.behance.net/project_modules/1400/706b9474134343.5c239806af449.jpg",
          genres: ["action", "drama"]
      },
      {
          title: "Dream Girl 2",
          description: "A sequel to Dream Girl that continues the comedic and romantic antics of the protagonist as he navigates new challenges in his life.",
          youtubeLink: "https://www.youtube.com/embed/XCtzPjrShnI?si=RxPeaKY7vI5i0B5S",
          thumbnail: "https://wallpapercave.com/wp/wp12868874.jpg",
          genres: ["comedy", "romance"]
      }
  ]
};

export default moviesData;
